import { AllModules } from "@bikdotai/bik-models/growth/models/feature";
import { Timestamp } from "firebase/firestore";

export enum SidebarEnums {
  "tailored-section" = "tailored-section",
  "recommended-section" = "recommended-section",
  "whats-new-section" = "whats-new-section",
  "service-features-section" = "service-features-section",
}
export interface UiMeta {
  title: string;
  desc: string;
  image: string;
  butttonText?: string;
  redirectUrl: string;
}

export enum JourneyLevels {
  BASIC = "basic",
  ADVANCED = "advanced",
  INTERMEDIATE = "intermediate",
}

export interface PostOnboardingJourneyRawI {
  id: AllModules | string;
  features: { level: JourneyLevels; uiMeta: UiMeta }[];
  type: string;
  selectedIndices?: number[];
  indicesToShow?: { [key in JourneyLevels]: number[] };
}

export type PostOnboardingJourney = {
  [key in Partial<AllModules>]: {
    features: EachTailoredSectionI[];
    selectedIndices?: number[];
  };
};

export type LocalIndicesI = {
  [key in Partial<AllModules>]: {
    [key in JourneyLevels]: number[];
  };
};
export interface EachTailoredSectionI {
  level: JourneyLevels;
  uiMeta: UiMeta;
  isSelected?: boolean;
}
export interface ChipButtonProps {
  onClick: () => void;
  buttonText: string;
  isSelected: boolean;
  dataTest?: string;
}

export interface EachWhatsNewContent {
  title: string;
  body: string;
  content: string;
  image: string;

  redirectUrl: string;
  docId: string;
  createdAt: Timestamp;
  // New fields from the design
  featureUpdateType?: "Major" | "Minor";
  module: string | string[]; // Support both single and multiple modules for backward compatibility
  featureTag?: string;
  pageUrls: string[];
  displayImage?: string;
  productVideo?: string;
  visibility: boolean;
  maxDisplayDuration?: number; // Number of days
  expirationDate?: Timestamp; // Creation time + maxDisplayDuration days
  archived?: boolean;
  
  showInFeed?: boolean;
  primaryButton?: ButtonConfig;
  secondaryButton?: SecondaryButtonConfig;


 
}

export interface ButtonStyle {
  textColor?: string;
  backgroundColor?: string;
  borderColor?: string;
}

export enum PrimaryButtonAction {
  PLAY_VIDEO = "Play Video",
  OPEN_LINK = "Open link",
}

export enum SecondaryButtonAction {
  OPEN_LINK = "Open link",
  CLOSE_POPUP = "Close popup",
  NONE = "",
}

export interface ButtonConfig {
  text?: string;
  action?: PrimaryButtonAction;
  redirectionUrl?: string;
  style?: ButtonStyle;
}

export interface SecondaryButtonConfig {
  text?: string;
  action?: SecondaryButtonAction;
  redirectionUrl?: string;
  style?: ButtonStyle;
}
